import React, { useEffect } from 'react';
import Overlay from '../FeatureComponents/Overlay';
import styled from "styled-components"
import closePopup from '../../../assets/imgs/close.svg';
import CrestGIF from '../../../assets/imgs/star5.gif';
import DepositImage from '../../../assets/imgs/DepositPopupGraphic.png';
import Axios from 'axios';
import {wrapperEndPoint} from "../../Utils/Api";

const OverlayMessage = (props) => {

 let popUpAnalyticsData;
    

 const handleClickNo = () => {
    
   props.toggleCrestPromotionPopUp();   
  //window['autosubmit'](props.overlayPopUpData.inputString2);

   popUpAnalyticsData = {botid: "vYdoWvH2CVMbJOGnAB11VA==",popupType:props.overlayPopUpData.popupType,applied:"N"}
  // console.log(popUpAnalyticsData);

    Axios.post(wrapperEndPoint.popUpAnalytics, popUpAnalyticsData)
    .then(response => {
        console.log(response);//handle sucess
    }).catch(error => {
        console.log(error);//handle error
    });

}

 const handleClickYes = () => {

  props.toggleCrestPromotionPopUp();
  //let inputString =   'I want to apply for Crest debit card.' + "<split>" + "I want to apply for Crest debit card";
  //let inputString =   'I want to apply for Crest debit card.';
  window['autosubmit'](props.overlayPopUpData.inputString1);
 
  popUpAnalyticsData = {botid: "vYdoWvH2CVMbJOGnAB11VA==",popupType:props.overlayPopUpData.popupType,applied:"Y"}
  //console.log(popUpAnalyticsData);

    Axios.post(wrapperEndPoint.popUpAnalytics, popUpAnalyticsData)
    .then(response => {
        console.log(response);//handle sucess
    }).catch(error => {
        console.log(error);//handle error
    });



}   
// onClick={()=>props.toggleCrestPromotionPopUp()}
    return (
        <PopUpOverlay>
            <PopUpContent>
                <div className="cross-wrapper">
                <img className="cross" onClick={()=>{handleClickNo()}} src={closePopup} alt="close popup"/></div>
             <div className= "image-div"><img src={props.overlayPopUpData.image}/></div>
            
                <div className="content-message-wrapper">
                <div className="title">
               {props.overlayPopUpData.title}
                </div>
                <div className="sub-title">
                {props.overlayPopUpData.subTitle}
                </div>

                <div className="desc">
                     {/* You are eligible for Crest debit card. Would you like to explore more? */}
                     
                     {props.overlayPopUpData.description}
                </div>
                <Button type="text" onClick={()=>{handleClickYes()}}>{props.overlayPopUpData.option1}</Button></div>
                {/* <Button type="text" onClick={()=>{handleClickNo()}}>{props.overlayPopUpData.option2}</Button> */}
            </PopUpContent>
        </PopUpOverlay>
    );
};

const PopUpOverlay = styled(Overlay)`
    top : 0;
    background : rgba(0,0,0,0.41);
    height: 100%;
    display : flex;
    justify-content : center;
    align-items : center;
`
const PopUpContent = styled.div`
    background : white;
  //  padding: 20px;
    padding-top :70px;
    width : 74%;
    text-align : center;
    position : relative;
    border-radius : 5px;


    .image-div{
        position: absolute;
        left:50%;
        transform: translateX(-50%);
        top:-60px;
//background: red;
        background: #fff;
        width: 150px;
        height: 150px;
        border-radius : 75px;
        overflow:hidden;
       // text-align: center;

    }

    .image-div img{
  
    //   width:80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 80%;
    max-height: 80%;
      
 
    
    }

    .cross-wrapper{
        position: absolute;
        top: -8px;
        right: -8px;
        cursor: pointer;
        width: 21px;
        height: 21px;
        border-radius : 10.5px;
        background: #fff;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        
    }

    .cross {
        // position: absolute;
        // top: 20px;
        // right: 20px;
        // cursor: pointer;
        // width:12px;
        // width: 12px;
    
        width:40%;
        padding-top: 6px;
    }

    .content-message-wrapper{
        padding: 20px;
        background: rgba(44,56,122,0.03);
     // background:red;
    }

    .title{
        font-size: 18px;
        font-weight: 500;
        color: #2c387a;
        margin: 14px 0px;
    }

    .sub-title{
        margin : 14px 0 14px 0;
        color: #2c387a;
        line-height: 20px;
        font-weight: 500;

    }

    .desc{
        margin : 0px 0 25px 0;
        color: #2c387a;
        line-height: 20px;
        
    }
`

const Button = styled.button`
    border: 0;
    color: white;
    height: 40px;
    display: block;
    font-size: 14px;
    border-radius: 20px;
    padding: 0 10px;
    width: 100%;
    box-shadow : none;
    outline : 0;
    margin: 15px 0;
    color : #ffffff;
    background : #2c387a;
    border : 1px solid #2c387a;
    cursor: pointer;

`

export default OverlayMessage;

  // color : ${props=>{
    //     return props.primary ? '#fff' : '#2c387a'
    // }};
    // background : ${props=>{
    //     return props.primary ? '#2c387a' : '#fff'
    // }};
    // border : ${props=>!props.primary && '1px solid #2c387a'};
    //here
    // color : #2c387a
    // background :#ffffff;
    // border : 1px solid #2c387a;
    // cursor: pointer;

    // &:hover{
    //     background: #2c387a ;
    //     color : #ffffff;
    // }